<template>
    <div class="about-page">
        <section class="hero-section" :style="{ backgroundImage: `url('${heroBackgroundImage}')` }">
            <NavbarSection />
            <div class="hero-overlay"></div>

            <div class="hero-content">
                <p class="hero-copy" v-html="description"></p>
            </div>
        </section>

        <main class="about-content">
            <DestinationSection />
            <OurStory />
            <OurValues />

            <section class="about-group" v-if="formattedPeople.length">
                <div class="section-header">
                    <h2>Our Pioneers</h2>
                    <p>Honoring the visionaries who laid the foundation of our club.</p>
                </div>
                <ImageSlider :people="formattedPeople" />
            </section>

            <section class="about-group" v-if="formattedPeople2.length">
                <div class="section-header">
                    <h2>Past Presidents</h2>
                    <p>Celebrating the leaders who have guided us through the years.</p>
                </div>
                <ImageSlider :people="formattedPeople2" />
            </section>

            <section class="about-group" v-if="formattedPeople3.length">
                <div class="section-header">
                    <h2>Board of Trustees</h2>
                    <p>Safeguarding our traditions and future growth.</p>
                </div>
                <ImageSlider :people="formattedPeople3" />
            </section>

            <section class="about-group" v-if="formattedPeople4.length">
                <div class="section-header">
                    <h2>Current Executive Committee</h2>
                    <p>Leading the club today with passion and purpose.</p>
                </div>
                <ImageSlider :people="formattedPeople4" />
            </section>

            <ContactUs />
        </main>

        <FooterSection />
    </div>
</template>

<script setup>
import FooterSection from '@/components/FooterSection.vue';
import DestinationSection from '@/components/AboutComponents/DestinationSection.vue';
import OurStory from '@/components/AboutComponents/OurStory.vue';
import OurValues from '@/components/AboutComponents/OurValues.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ImageSlider from '@/components/AboutComponents/ImageSlider.vue';
import ContactUs from '@/components/AboutComponents/ContactUs.vue';
import { computed, ref, onMounted } from "vue";
import axios from 'axios';
import heroImage from '@/assets/images/herobackground.png';

const heroBackgroundImage = ref(heroImage);
const description = ref('');
const dataList = ref([]);
const dataList2 = ref([]);
const dataList3 = ref([]);
const dataList4 = ref([]);

let base_url = process.env.VUE_APP_BASE_LIVE_URL;

onMounted(async () => {
  await listBanner();
  await listPioneers();
  await listPastPresident();
  await listCurrentExecutives();
  await listBoardOfTrustees();
});

const formattedPeople = computed(() =>
  dataList.value.map((person) => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
);

const formattedPeople2 = computed(() =>
  dataList2.value.map((person) => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
);

const formattedPeople3 = computed(() =>
  dataList3.value.map((person) => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
);

const formattedPeople4 = computed(() =>
  dataList4.value.map((person) => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
);

const listBanner = async () => {
  try {
    const config = 'aboutus';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`);
    const banner = Array.isArray(response.data.data) ? response.data.data[0] : (response.data.data || {});
    description.value = banner.description || '';
    heroBackgroundImage.value = banner.banner_image ? `${base_url}${banner.banner_image}` : heroImage;
  } catch (error) {
    console.error(error.message);
    heroBackgroundImage.value = heroImage;
  }
};

const listPioneers = async () => {
  try {
    const response = await axios.get('/pioneers_list.php');
    dataList.value = response.data.status ? response.data.data : [];
  } catch (error) {
    console.error(error.message);
  }
};

const listPastPresident = async () => {
  try {
    const response = await axios.get('/past_presidents_list.php');
    dataList2.value = response.data.status ? response.data.data : [];
  } catch (error) {
    console.error(error.message);
  }
};

const listBoardOfTrustees = async () => {
  try {
    const response = await axios.get('/boardof_trustees_list.php');
    dataList3.value = response.data.status ? response.data.data : [];
  } catch (error) {
    console.error(error.message);
  }
};

const listCurrentExecutives = async () => {
  try {
    const response = await axios.get('/current_executives_list.php');
    dataList4.value = response.data.status ? response.data.data : [];
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style scoped lang="scss">
.about-page {
    background: linear-gradient(180deg, #f7f8fb 0%, #ffffff 35%);
}

.hero-section {
    position: relative;
    min-height: 560px;
    margin: 16px;
    border-radius: 28px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(6, 16, 10, 0.18), rgba(6, 16, 10, 0.72));
}

.hero-content {
    position: relative;
    z-index: 1;
    max-width: 820px;
    margin: 0 auto;
    padding: 180px 24px 80px;
    text-align: center;
    color: #fff;
}

.eyebrow {
    margin: 0 0 12px;
    font-size: 12px;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    opacity: 0.85;
}

.hero-content h1 {
    margin: 0;
    font-size: clamp(40px, 5vw, 64px);
    line-height: 1.02;
    font-weight: 700;
}

.hero-copy {
    margin: 16px auto 0;
    max-width: 720px;
    font-size: 18px;
    line-height: 1.75;
    opacity: 0.94;
}

.about-content {
    display: flex;
    flex-direction: column;
    gap: 72px;
    padding: 36px 24px 0;
}

.about-group {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
}

.section-header {
    text-align: center;
    margin-bottom: 24px;
}

.section-kicker {
    margin: 0 0 8px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-header h2 {
    margin: 0;
    font-size: clamp(28px, 3vw, 44px);
    font-weight: 700;
    color: #0f172a;
}

.section-header p {
    margin: 10px auto 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.about-group .section-header {
    margin-bottom: 40px;
}

.about-group .section-header h2 {
    font-size: 48px;
    font-weight: 700;
    color: #000000;
}

.about-group .section-header p {
    max-width: 820px;
    font-size: 20px;
    font-weight: 500;
    color: #555555;
}

@media (max-width: 768px) {
    .hero-section {
        min-height: 420px;
        margin: 12px;
        border-radius: 22px;
    }

    .hero-content {
        padding: 132px 18px 48px;
    }

    .hero-content h1 {
        font-size: 34px;
    }

    .hero-copy {
        font-size: 16px;
    }

    .about-content {
        gap: 48px;
        padding: 24px 16px 0;
    }

    .section-header {
        margin-bottom: 18px;
    }
}
</style>
